var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 40V32H0L7.7 20H4L18 0L24 8.6L30 0L44 20H40.3L48 32H34V40H26V32H22V40H14ZM33.45 28H40.7L32.95 16H36.3L30 7L26.45 12.05L32 20H28.3L33.45 28ZM7.3 28H28.7L20.95 16H24.3L18 7L11.7 16H15.05L7.3 28ZM7.3 28H15.05H11.7H18H24.3H20.95H28.7H7.3ZM33.45 28H28.3H32H26.45H30H36.3H32.95H40.7H33.45Z",
    fill: "#FDC82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestConversation);
export default __webpack_public_path__ + "static/media/forest-conversation.fccef9dab824903f7bec3792d10d6119.svg";
export { ForwardRef as ReactComponent };